import React, { useState } from "react";
import { Link } from 'react-router-dom';
import logo from '../../assets/images/logo.png';
import { showToast, ToastMessage } from "../Shared/ToastMessage";
import axios from "axios";
import { baseUrl, ROUTE_BASE_URL } from "../../api/common";
export default function ForgotPassword({}) {

	const [email, setEmail] = useState("");

	const sendPassword = async () => {
		if (!email) {
		  showToast("Email cannot be empty", "error");
		  return;
		}	
		try {
		  const response = await axios.post(
			`${baseUrl}/api/adminforgotpassword`,
			{ 
				email: email,
			 },
			{
			  headers: {
				"Content-Type": "application/json",
				Authorization: localStorage.getItem("access_token"),
			  },
			}
		  );
		  if (response.data.status) {
			showToast(response.data.message, "success");
			setEmail("");
		  } else {
			showToast(response.data.message, "error");
		  }
		} catch (error) {
		  console.error("Error during submission:", error);
		  showToast("A network error occurred, or the server is temporarily busy. Please try again later.", "error");
		}
	};	

	return (
	  <>
	      <ToastMessage /> 
		  <div className="auth-main particles_js">
			  <div className="auth_div vivify popIn forgot-width">
				  <div className="auth_brand">
					  <Link to={`${ROUTE_BASE_URL}/login`}>
					  <img
							src={logo}
							// src="https://cdn.prod.website-files.com/66712a83ccf4e64be43d1817/66712f8f27aaed354f88a0b7_amasi_logo.png"
							width="80"
							height="80"
							className="d-inline-block align-top mr-2"
							alt="AMASI"
						/>					  
						</Link>
				  </div>
				  <div className="card forgot-pass">
					  <div className="body">
						  <p className="lead mb-3"><strong>Forgot your Email?</strong></p>
						  <div className="form-group pos_relative text-left">
						  <label>
						  Email <span className="text-danger">*</span>
						  </label>
						  <input
							  type="email"
							  value={email}
							  onChange={e => setEmail (e.target.value)}
							  className="form-control"
							  placeholder="Enter your Email"
						  />
						  </div>
						  <button onClick={()=>sendPassword()} className="btn btn-outline-primary btn-block">Submit</button>
					  </div>
				  </div>
			  </div>
			  <div id="particles-js"></div>
		  </div>
	  </>
  );
}
